import { type SerializedStyles, css } from '@emotion/react';

const tooltip = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '5px 8px',
    color: '#080F1A',
    background: '#fff',
    borderRadius: 4,
    boxShadow: '0px 8px 20px rgba(0, 27, 71, 0.24)',
    fontSize: 14,
    lineHeight: '18px',
    textAlign: 'center',
    position: 'absolute',
    bottom: 'calc(100% - 4px)',
    left: '50%',
    transform: 'translate(-50%, 10px)',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.16s ease-in-out, transform 0.16s ease-in-out',
    zIndex: 10,
    whiteSpace: 'nowrap',
    gap: '8px',
});

const tooltipButton = ({ showOnDisabled = false } = {}): SerializedStyles =>
    css({
        '@media (hover: hover)': {
            [`&:${showOnDisabled ? '' : 'not([disabled]):'}hover .tooltip:not(.clicked)`]: {
                opacity: 1,
                transform: 'translate(-50%, -10px)',
            },
        },
        [`&:${showOnDisabled ? '' : 'not([disabled]):'}active .tooltip`]: {
            opacity: 0,
            pointerEvents: 'none',
        },
    });

export default { tooltipButton, tooltip };
